import type { Deactivation2Config } from '@elfsight/widget-deactivation';
import { Deactivation2 } from '@elfsight/widget-deactivation';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../meta';

const { appAlias } = meta;

type DeactivationProps = Omit<
  Deactivation2Config,
  'appAlias' | 'displayDeactivation' | 'deactivationURL'
>;

export function Deactivation({
  children,
  ...forwardingProps
}: DeactivationProps) {
  const { displayDeactivation, deactivationURL } = useSettings();

  return (
    <Deactivation2
      {...forwardingProps}
      appAlias={appAlias}
      displayDeactivation={displayDeactivation}
      deactivationURL={deactivationURL}
    >
      {children}
    </Deactivation2>
  );
}
